import { Input, Form } from "antd";
import styles from './styles.module.scss';
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { validateEmail } from "utils";
import { useDispatch, useSelector } from "react-redux";
import { createSelector } from "reselect";
import { TStore } from "models";
import { requestMagicLink } from "store/actions/auth";
import FormInput from "components/FormInput";
import FormWrapper from "components/FormWrapper";
import CustomButton from "components/Button";

const stateSelectorHandle = createSelector(
	(state: TStore) => state.app.loading,
	(loading) => ({ loading }),
);

const MagicLinkForm = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const stateSelector = useCallback(stateSelectorHandle, []);
    const { loading } = useSelector(stateSelector);

    const handleMagicLinkRequest = useCallback(
        (values: { email: string }) => {
            dispatch(
                requestMagicLink({
                    email: values.email.trim(),
                    onSuccess: () => navigate("/auth/sign-in")
                })
            );
            // Navigation happens in the saga after successful request
        },
        [dispatch, navigate]
    );

    return (
        <FormWrapper>
            <div className={styles.titleMagicLink}>
                Login with Magic Link
            </div>
            <p className={styles.subTitle}>
                Enter your email address and we'll send you a magic link to sign in without a password.
            </p>
            <Form
                className={styles.form}
                onFinish={handleMagicLinkRequest}
            >
                <FormInput
                    label="Email"
                    name="email"
                    rules={[
                        {
                            required: true,
                            message: "Please enter your email address!",
                        },
                        () => ({
                            validator(_, value) {
                                const WARNING_MSG =
                                    "Please enter your email address in the format email@example.com!";
                                if (!value) {
                                    return Promise.reject(WARNING_MSG);
                                }
                                if (validateEmail(value)) {
                                    return Promise.resolve();
                                } else {
                                    return Promise.reject(WARNING_MSG);
                                }
                            },
                        }),
                    ]}
                >
                    <Input type="text" placeholder="Enter your email" />
                </FormInput>
                <FormInput className={styles.formItemCenteredNoBorderBtn}>
                    <CustomButton
                        htmlType="submit"
                        loading={loading}
                        buttonText="Send Magic Link"
                    />
                </FormInput>
                <div className={styles.linkContainer}>
                    <span onClick={() => navigate("/auth/sign-in")} className={styles.underlinedTextWithPrimaryColorLink}>
                        Back to Login
                    </span>
                </div>
            </Form>
        </FormWrapper>
    );
};

export default MagicLinkForm; 